import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHypothesisComponent } from './simple-icons-hypothesis.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHypothesisComponent ],
    exports:      [ SimpleIconsHypothesisComponent ],
    bootstrap:    []
})
export class SimpleIconsHypothesisModule {}
